export const AOS_CONFIG = {
  once: true,
  offset: 80,
  duration: 600,
  easing: 'ease-out-cubic',
};
